var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Marker"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marker",
    clipPath: "url(#clip-Marker)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1949",
    "data-name": "Group 1949",
    transform: "translate(9 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M22.968,0a10.8,10.8,0,1,0,10.8,10.8A10.8,10.8,0,0,0,22.968,0Zm0,16.4a5.6,5.6,0,1,1,5.576-5.6,5.6,5.6,0,0,1-5.576,5.6Z",
    transform: "translate(-12.17)",
    fill: "#d90429"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M32.889,38.16l-4.871,13.7a.562.562,0,0,1-1.059,0L22.073,38.166A11.33,11.33,0,0,0,32.89,38.16Z",
    transform: "translate(-16.68 -17.381)",
    fill: "#ef233c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.020f6bbf.svg";
export { ForwardRef as ReactComponent };